export default __webpack_public_path__ + "static/media/pic2.a79b7973.jpg";